// Loads the Google Maps JS API (Places library) once, on demand.
// Uses Google's official dynamic bootstrap loader so nothing loads until the
// address field is first focused - keeps the landing page fast.

const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
let placesPromise = null;

const injectBootstrap = () => {
  if (window.google?.maps?.importLibrary) return;
  /* eslint-disable */
  ((g) => { var h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window; b = b[c] || (b[c] = {}); var d = b.maps || (b.maps = {}), r = new Set, e = new URLSearchParams, u = () => h || (h = new Promise(async (f, n) => { await (a = m.createElement("script")); e.set("libraries", [...r] + ""); for (k in g) e.set(k.replace(/[A-Z]/g, t => "_" + t[0].toLowerCase()), g[k]); e.set("callback", c + ".maps." + q); a.src = `https://maps.${c}apis.com/maps/api/js?` + e; d[q] = f; a.onerror = () => h = n(Error(p + " could not load.")); a.nonce = m.querySelector("script[nonce]")?.nonce || ""; m.head.append(a) })); d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)) })({ key: API_KEY, v: "weekly", region: "AU", language: "en-AU" });
  /* eslint-enable */
};

export const isPlacesConfigured = () => Boolean(API_KEY);

export const loadPlaces = () => {
  if (!API_KEY) return Promise.reject(new Error('Google Maps API key not configured'));
  if (!placesPromise) {
    injectBootstrap();
    placesPromise = window.google.maps.importLibrary('places').catch((err) => {
      placesPromise = null; // allow retry on transient failure
      throw err;
    });
  }
  return placesPromise;
};

// Flatten Google addressComponents into the fields our form/backend use.
export const parseAddressComponents = (components = []) => {
  const get = (type, short = false) => {
    const c = components.find((x) => x.types.includes(type));
    return c ? (short ? c.shortText : c.longText) : '';
  };
  const streetNumber = get('street_number');
  const route = get('route');
  const subpremise = get('subpremise');
  const street = [subpremise && `${subpremise}/`, streetNumber, route].filter(Boolean).join(' ').replace('/ ', '/');
  return {
    street,
    suburb: get('locality') || get('sublocality') || get('postal_town'),
    state: get('administrative_area_level_1', true),
    postcode: get('postal_code'),
  };
};
